import { useState } from 'react';
import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  const [imgError, setImgError] = useState(false);

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-0">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-5">
              {heroData.tag}
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              {heroData.title}
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading italic font-semibold mb-6">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl lg:max-w-none mb-8">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(heroData.primaryCta.href);
                }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                {heroData.primaryCta.label}
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(heroData.secondaryCta.href);
                }}
                className="inline-flex items-center gap-2 px-8 py-3 border-2 border-secondary-300 text-foreground-700 font-semibold rounded-lg hover:border-secondary-500 hover:text-foreground-950 transition-colors duration-200 cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-bar-chart-line text-lg"></i>
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            {!imgError ? (
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20abstract%20composition%20with%20warm%20amber%20and%20deep%20crimson%20lighting%2C%20layered%20film%20reel%20silhouettes%2C%20soft%20bokeh%20effects%2C%20dark%20theater%20atmosphere%2C%20elegant%20minimalist%20design%2C%20artistic%20movie-inspired%20visual%20with%20rich%20textures%20and%20subtle%20grain%2C%20luxurious%20cinema%20aesthetic%2C%20golden%20spotlights%20on%20dark%20backdrop&width=1200&height=900&seq=hero-main-visual-2026&orientation=landscape"
                alt="草民影院 - 免费高清影视在线观看平台主题视觉"
                className="w-full h-auto rounded-2xl object-cover"
                onError={() => setImgError(true)}
              />
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
}